import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import configureStore, { history } from 'store/store';
import Root from 'components/App/Root';
import * as serviceWorker from './serviceWorker';
import './styles/main.scss';

const store = configureStore();

const reactElement = document.getElementById('root');

render(<Root
  store={store}
  history={history}
  brand={reactElement.getAttribute('data-cinema')}
/>, reactElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
